import { ProjectTypes } from "../../constants/projectTypes";

export const projectsInfo =[
    {
        id:0,
        type:ProjectTypes.REACTJS,
        title:"Portfolio",
        description:"Deze website dient om mijn portfolio weer te geven. Hierbij zie je op de Home pagina wat informatie over mij zoals mijn werkervaring, opleiding enz..\n\nDaarnaast is er nog een aparte pagina die mijn projecten weergeeft. Hierbij staat er wat uitleg over het project en in welk framework het is gemaakt. Ook is er een link naar de github ervan.\n\nDit project diende ook om React JS te leren. De interesse kwam doordat ik tijdens mijn stage in Proceedix leerde werken met React Native. Hierbij wilde ik zien of React JS en React Native veel verschillen van elkaar.",
        link:"https://github.com/VanheeAyron/Portfolio",
    },
    {
        id:1,
        type:ProjectTypes.SVELTEJS,
        title:"Svelte Cinema Webapp",
        description:"Dit project maakte deel uit van het technische onderzoek van mijn bachelorproef. Hierin testte ik uit tot wat Svelte in staat is.\n\nDeze website dient als een cinema website waarbij een gebruik kan kiezen uit een paar films om daarna een ticket te kopen. Hieruit kan de gebruiker dan nog eens kiezen om hoe laat hij wilt gaan en op welke dag. Ook kan een admin gebruiker vertoningen toevoegen.\n\nHierbij werd er gebruik gemaakt van een lokale ASP.NET Core API.",
        link:"https://github.com/VanheeAyron/Svelte-Cinema-Webapp",
    },
    {
        id:2,
        type:ProjectTypes.XAMARIN,
        title:"Xamarin Movie renter",
        description:"Op deze app kon een gebruiker een film huren en daarna een comment achterlaten op deze film.\n\n De gebruiker kon dan een overzicht zien van alle films die hij heeft gehuurd en alle comments die hij had achtergelaten.\n\nDeze maakte gebruik van een API die online stond maar die is nu offline.",
        link:"https://github.com/VanheeAyron/MovieRenter.git",
    },

    {
        id:3,
        type:ProjectTypes.ASPNETCORE,
        title:"Cinema API",
        description:"Deze api werkt in samenwerking met de Svelte Cinema Webapp en Vue Cinema Website.\n\nMet deze API kan de gebruiker films ophalen. Deze films kunnen dan ook een vertoning bevatten. Bij een vertoning zal de gebruiker kunnen kiezen uit een zaal en de datum\tijd. Hij kan daarna een ticket kopen.\n\nOok is er een login systeem. Hierbij zijn er 2 type users. Gewone users en admin users. Gewone users kunnen tickets kopen. Admins kunnen nog eens vertoningen toevoegen.\n\nDeze werkt met een lokale database (MSSQL). Deze wordt aangemaakt a.d.h.v. de seeder.",
        link:"https://github.com/VanheeAyron/CinemaApi",
    },

    {
        id:4,
        type:ProjectTypes.VUEJS,
        title:"Vue Cinema Website",
        description:"Dit is een cinema website waarbij gebruikers tickets kunnen kopen voor een film. Deze maakt gebruik van de Cinema API die gemaakt is in ASP.NET Core.\n\nBasis functionaliteiten:\n\nDe gebruiker kan cinematickets kopen via de web app.\nDe tickets bevatten de cinemazaal, de film: enkel als die nog niet begonnen is en een zetel naar keuze: (2 soorten zetels: gewone en speciale)\n\nType gebruikers\n\nEr zijn 3 soorten gebruikers:\nreguliere gebruikers: enkel films zien\ningelogde gebruikers: films zien en tickets bestellen\nadmins: films toevoegen en gebruikers beheren.",
        link:"https://github.com/VanheeAyron/Vue-Cinema-Website",
    },

    {
        id:5,
        type:ProjectTypes.VUEJS,
        title:"Vue ToDo Website",
        description:"Met deze website wordt er op de home pagina een klok weergegeven met de datum.\n\nEr kan worden doorgeklikt om verschillende todo's toe te voegen. Dez worden dan opgeslagen in indexedDB.\n\nDe website kan ook worden omgezet in verschillende talen.",
        link:"https://github.com/VanheeAyron/Vue-Todo-App",
    },

    {
        id:6,
        type:ProjectTypes.VUEJS,
        title:"Simple Black Jack",
        description:"Op deze website kan er Black Jack gespeeld worden. Het doel van het spel is om de dealer te verslaan. Hierbij moet je proberen dichter bij de 21 punten te komen dan de dealer. Als je boven de 21 punten uitkomt heb je verloren, ongeacht wat de dealer zijn kaarten zijn.\n\nDit project maakt gebruik van de 'Deck of Cards' API. ",
        link:"https://github.com/VanheeAyron/Simple-BlackJack",
        preview:"https://ayron-vanhee-simple-black-jack.netlify.app/#/"
    }
]